import { Lightning } from '@lightningjs/sdk';
import { RENDERING_CONTEXT } from '@bedrock-rdk/constants';
import { defaultContext } from './skelton.style';
import { getBlockSkeleton } from './skelton.constants';
import { getContentSizeByContentTemplateId, getContentTemplateByTemplateId } from '../templates';

export class Skeleton extends Lightning.Component {
  static _template() {
    return {
      alpha: 0.25,
      Rows: {},
    };
  }

  _construct() {
    this._style = defaultContext;
  }

  get ignoresContentPadding() {
    return false;
  }

  /**
   * Whether the content is sized the way a search page sizes it, as search items and blocks
   * are laid out within a narrower area
   *
   * @returns {boolean}
   */
  get isSearchPage() {
    return false;
  }

  set rows(value) {
    this.tag('Rows').children = this._makeRows(value);
  }

  /**
   * Builds a vertical stack of block placeholders out of a skeleton configuration
   *
   * @param {Array} value list of block skeleton template ids or their configurations
   * @returns {Array} Lightning children patches
   */
  _makeRows(value) {
    let offset = 0;
    const children = [];

    for (let i = 0; i < value.length; i += 1) {
      const entry = value[i];
      const hasProps = Boolean(entry.blockTemplate);
      const data = {
        entry,
        screenSize: this._style.screenSize,
        blockIndex: i,
        itemTemplate: entry.itemTemplate,
      };
      const blockSkeletonTemplateId = hasProps ? entry.blockTemplate : entry;
      const block = getBlockSkeleton(blockSkeletonTemplateId);
      const h = block.getHeight(data);

      children.push({
        type: block,
        y: offset,
        h,
        items: {
          entry,
          count: entry.count || 8,
          itemTemplate: entry.itemTemplate,
          itemType: getContentTemplateByTemplateId(entry.itemTemplate),
          itemSize: getContentSizeByContentTemplateId(
            entry.itemTemplate,
            this.isSearchPage ? RENDERING_CONTEXT.SEARCH : RENDERING_CONTEXT.GENERAL,
          ),
          blockIndex: i,
        },
      });
      offset += h;
    }

    return children;
  }
}
